// removed by extract-text-webpack-plugin
module.exports = {"table-wrapper":"ResourceList__table-wrapper___f6Lvn","resource-list":"ResourceList__resource-list___3z1gP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DevicePage/ResourceList/ResourceList.css
// module id = 354
// module chunks = 0